// export DsfScStaticList from './staticList';
export const DsfScStaticList = Vue.defineLazyComponent(()=>require('./staticList.vue'));